export const LOAD_CHAT_PUBLIC_DATA_REQUEST = 'LOAD_CHAT_PUBLIC_DATA_REQUEST';
export const LOAD_CHAT_PUBLIC_DATA_SUCCESS = 'LOAD_CHAT_PUBLIC_DATA_SUCCESS';
export const LOAD_CHAT_PUBLIC_DATA_FAILURE = 'LOAD_CHAT_PUBLIC_DATA_FAILURE';

